const heading1 = () => {
  return {
    fontSize: 24,
    fontWeight: 900,
    letterSpacing: "1.6px",
  };
};

const heading2 = () => {
  return {
    fontSize: 25,
    fontWeight: 400,
    letterSpacing: "2px",
  };
};

const heading3 = () => {
  return {
    fontSize: 20,
    fontWeight: 500,
    letterSpacing: "2px",
  };
};

const heading4 = () => {
  return {
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: "2px",
  };
};

export { heading1, heading2, heading3, heading4 };
